import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from "@mui/material/Box";
import Topbar from "./Topbar";
import Button from "@mui/material/Button";
import { Avatar, TextField, Pagination, TableSortLabel } from "@mui/material";
import { db } from "../../firebase.js";

import { getDatabase, ref, query, child, orderByChild, equalTo, get, update } from "firebase/database";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Stack, List, ListItem, ListItemText, Divider, Typography } from '@mui/material';


// Dicionário para traduzir os nomes dos campos da base de dados para Português de Portugal
const LABELS_PT = {
    FirstName: "Primeiro Nome",
    LastName: "Último Nome",
    Email: "Email",
    PhoneNumber: "Telefone",
    Gender: "Género",
    ProfileType: "Tipo de Perfil",
    AcademicTitles: "Grau Académico",
    Course: "Curso",
    Subcollege: "Colégio / Área",
    University: "Universidade",
    StudentNumber: "Nº de Estudante",
    OENumber: "Número OE",
    Company: "Empresa",
    Address: "Morada",
    Linkedin: "LinkedIn",
    OtherInfo: "Outras Informações",
    RegisterDate: "Data de Registo",
    Points: "Pontos"
};

// Campos que NUNCA queremos mostrar como texto
const GLOBAL_HIDDEN_KEYS = [
    "Dicas", "Enabled", "Id", "uid", "Lat", "Lon", "ProfileURL", "Usertoken", "EmailVerified", "password", "Password"
];

// Função que decide se uma linha deve ou não aparecer no popup
const isFieldVisible = (key, value, profileType) => {
    // 1. Ocultar se o valor for vazio
    if (value === null || value === undefined || value === "") return false;

    // 2. Ocultar os campos globais técnicos
    if (GLOBAL_HIDDEN_KEYS.includes(key)) return false;

    // 3. Ocultar dependendo do tipo de perfil
    if (profileType === "Membro OE") {
        if (key === "StudentNumber" || key === "University") return false;
    } else if (profileType === "Estudante") {
        if (key === "OENumber") return false;
    }

    return true;
};


const Users = () => {


    const [users, setUsers] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage, setUsersPerPage] = useState(5);
    const [selectedUser, setSelectedUser] = useState(null); // State for the selected user
    const [openDialog, setOpenDialog] = useState(false); // State to control dialog visibility
    const [sortField, setSortField] = useState('RegisterDate');
    const [sortOrder, setSortOrder] = useState('desc');



    async function updateEnabledParameter(userID, newEnabledValue) {
        const db = getDatabase();

        const updates = {};
        updates['/User/' + userID + '/Enabled'] = newEnabledValue;

        try {
            await update(ref(db), updates);
            setUsers((prevUsers) =>
                prevUsers.map((user) =>
                    user.uid === userID ? { ...user, Enabled: newEnabledValue } : user
                )
            );
            console.log('Enabled parameter updated successfully');
        } catch (error) {
            console.error('Error updating enabled parameter:', error.message);
        }

        // Update local state with the modified user data

    }


    const fetchUsers = async () => {
        try {
            const apiKey = 'your-api-key';
            const databaseURL = 'https://engenheirossemfronteiros-default-rtdb.europe-west1.firebasedatabase.app/';
            const endpoint = `User.json?apiKey=${apiKey}`;

            const response = await fetch(`${databaseURL}/${endpoint}`);

            if (!response.ok) {
                throw new Error(`Error fetching user list: ${response.statusText}`);
            }

            const usersData = await response.json();

            console.log(usersData)

            if (!usersData) {
                console.error('No users found.');
                return;
            }
            const usersList = Object.entries(usersData)
                .map(([uid, usersData]) => ({ uid, ...usersData }))
                // Só contas inativas com email verificado (ou já ativas) aparecem
                // para aprovação; pendentes sem email verificado ficam ocultas.
                .filter(u => u.Enabled !== false || u.EmailVerified === true);

            const sortedUsersList = usersList.sort((a, b) => (a.Enabled === b.Enabled ? 0 : a.Enabled ? 1 : -1));

            setUsers(sortedUsersList);
        } catch (error) {
            console.error('Error fetching user list:', error.message);
        }
    };
    useEffect(() => {
        fetchUsers();
    }, []);

    const deleteUser = async (uid) => {
        try {
            const apiKey = 'your-api-key';
            const databaseURL = 'https://engenheirossemfronteiros-default-rtdb.europe-west1.firebasedatabase.app/';
            const endpoint = `User/${uid}.json?apiKey=${apiKey}`;

            const response = await fetch(`${databaseURL}/${endpoint}`, {
                method: 'DELETE',
            });

            if (!response.ok) {
                throw new Error(`Error deleting user: ${response.statusText}`);
            }

            console.log(`User com UID ${uid} apagada com sucesso.`);
            await fetchUsers();
        } catch (error) {
            console.error('Erro ao apagar a associação:', error.message);
        }
    };



    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
        setCurrentPage(1);
    };

    const handleSort = (field) => {
        const isAsc = sortField === field && sortOrder === 'asc';
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortField(field);
    };

    // 1. Filtrar pela pesquisa
    const filteredUsers = users.filter(user =>
        user.Email?.toLowerCase().includes(searchQuery) ||
        user.Company?.toLowerCase().includes(searchQuery) ||
        user.Course?.toLowerCase().includes(searchQuery) ||
        user.Subcollege?.toLowerCase().includes(searchQuery) ||
        user.OENumber?.toLowerCase().includes(searchQuery)
    );

    // 2. Parse limpo para formato DD/MM/YYYY HH:MM:SS
    const parseDateString = (dateStr) => {
        if (!dateStr) return 0;
        const parts = dateStr.trim().split(/[\s/:]+/);
        if (parts.length < 3) return 0;
        return new Date(parts[2], parts[1] - 1, parts[0], parts[3] || 0, parts[4] || 0, parts[5] || 0).getTime();
    };

    // 3. Ordenar a lista filtrada
    const sortedUsers = filteredUsers.sort((a, b) => {
        // Regra 1: Desativados no topo
        if (Boolean(a.Enabled) !== Boolean(b.Enabled)) {
            return a.Enabled ? 1 : -1;
        }

        // Regra 2: Ordenação pelo campo clicado (Email ou RegisterDate)
        if (sortField === 'RegisterDate') {
            const dateA = parseDateString(a.RegisterDate);
            const dateB = parseDateString(b.RegisterDate);
            if (dateA < dateB) return sortOrder === 'asc' ? -1 : 1;
            if (dateA > dateB) return sortOrder === 'asc' ? 1 : -1;
            return 0;
        } else {
            let valA = a[sortField] || '';
            let valB = b[sortField] || '';
            if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
            if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
            return 0;
        }
    });

    // 4. Paginação baseada nos utilizadores ORDENADOS
    const totalPages = Math.ceil(sortedUsers.length / usersPerPage);
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = sortedUsers.slice(indexOfFirstUser, indexOfLastUser);

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };



    const handleOpenDialog = (user) => {
        setSelectedUser(user);
        setOpenDialog(true);
    };
    // Function to close the dialog
    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (

        <Box sx={{ flexGrow: 1 }}>

            <Topbar />
            <TextField
                fullWidth
                label="Pesquisar"
                variant='outlined'
                sx={{ margin: "8px", width: 'calc(100% - 16px)' }}
                onChange={handleSearchChange}
            />
            <Paper elevation={1} className={"mt-4"} sx={{ margin: "0 8px" }}>

                <TableContainer component={Paper} class={"mt-4"} sx={{ mt: 4, overflow: 'hidden', borderRadius: '12px', boxShadow: '0px 4px 12px rgba(0,0,0,0.1)' }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead sx={{ backgroundColor: '#1C4E80' }}>
                            <TableRow>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}> </TableCell>

                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
                                    <TableSortLabel
                                        active={sortField === 'Email'}
                                        direction={sortField === 'Email' ? sortOrder : 'asc'}
                                        onClick={() => handleSort('Email')}
                                        sx={{ color: 'white !important', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
                                    >
                                        Email
                                    </TableSortLabel>
                                </TableCell>

                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Empresa</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Curso</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Colégio</TableCell>

                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
                                    <TableSortLabel
                                        active={sortField === 'RegisterDate'}
                                        direction={sortField === 'RegisterDate' ? sortOrder : 'asc'}
                                        onClick={() => handleSort('RegisterDate')}
                                        sx={{ color: 'white !important', '& .MuiTableSortLabel-icon': { color: 'white !important' } }}
                                    >
                                        Data Registo
                                    </TableSortLabel>
                                </TableCell>

                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Nrº OE</TableCell>
                                <TableCell align="right" sx={{ color: 'white', fontWeight: 'bold' }}>Estado</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {currentUsers.map((user, index) => (
                                <TableRow
                                    key={user.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' } }}
                                    onClick={() => handleOpenDialog(user)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <TableCell>
                                        <Avatar
                                            alt={user.Email || 'N/A'}
                                            src={user.ProfileURL}
                                        /></TableCell>
                                    <TableCell >
                                        {user.Email || 'N/A'}
                                    </TableCell>
                                    <TableCell>{user.Company || 'N/A'}</TableCell>
                                    <TableCell>{user.Course || 'N/A'}</TableCell>
                                    <TableCell>{user.Subcollege || 'N/A'}</TableCell>
                                    <TableCell>{user.RegisterDate || 'N/A'}</TableCell>
                                    <TableCell>{user.OENumber || 'N/A'}</TableCell>
                                    <TableCell align={"right"}>
                                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                                            {!user.Enabled && (
                                                <Button
                                                    variant="outlined"
                                                    color="error"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        deleteUser(user.uid);
                                                    }}
                                                >
                                                    Apagar
                                                </Button>
                                            )}
                                            <Button variant={user.Enabled ? 'contained' : 'outlined'}
                                                color={user.Enabled ? 'success' : "error"}
                                                onClick={(event) => (
                                                    event.stopPropagation(),
                                                    updateEnabledParameter(user.uid, !user.Enabled))}>
                                                {
                                                    user.Enabled ? "Ativo" : "Ativar"
                                                }
                                            </Button>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Pagination count={totalPages} page={currentPage} onChange={handleChangePage} sx={{ '.MuiPaginationItem-root': { borderRadius: '4px' } }} />
                </Box>
            </Paper>

            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', color: '#1C4E80' }}>
                    Detalhes do Voluntário
                </DialogTitle>

                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2, mt: 1 }}>

                        {/* A Imagem continua a aparecer no topo */}
                        <Avatar
                            alt={selectedUser?.Email || 'N/A'}
                            src={selectedUser?.ProfileURL}
                            sx={{ width: 120, height: 120, mb: 3, boxShadow: '0px 4px 10px rgba(0,0,0,0.1)' }}
                        />

                        {/* Tabela dinâmica com os dados */}
                        {selectedUser && (
                            <Box sx={{ width: '100%', px: 2 }}>
                                {Object.entries(selectedUser)
                                    .filter(([key, value]) => isFieldVisible(key, value, selectedUser.ProfileType))
                                    .sort(([keyA], [keyB]) => {
                                        // Puxar o Tipo de Perfil e Email para o topo
                                        if (keyA === "ProfileType") return -1;
                                        if (keyB === "ProfileType") return 1;
                                        if (keyA === "Email") return -1;
                                        if (keyB === "Email") return 1;
                                        return 0; // O resto fica na ordem que vem da base de dados
                                    })
                                    .map(([key, value]) => (
                                        <Box key={key} sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            borderBottom: '1px solid #e0e0e0',
                                            py: 1.5
                                        }}>
                                            <Typography sx={{ fontWeight: 'bold', color: '#555', width: '40%' }}>
                                                {LABELS_PT[key] || key}:
                                            </Typography>

                                            {/* Formatar Links (ex: LinkedIn ou Email) */}
                                            {key === 'Email' ? (
                                                <Typography sx={{ width: '60%', textAlign: 'right', wordBreak: 'break-word' }}>
                                                    <a href={`mailto:${value}`} style={{ color: '#1C4E80', textDecoration: 'none' }}>{value}</a>
                                                </Typography>
                                            ) : key === 'Linkedin' && value.includes('http') ? (
                                                <Typography sx={{ width: '60%', textAlign: 'right', wordBreak: 'break-word' }}>
                                                    <a href={value} target="_blank" rel="noreferrer" style={{ color: '#1C4E80', textDecoration: 'none' }}>Ver Perfil</a>
                                                </Typography>
                                            ) : (
                                                <Typography sx={{ width: '60%', textAlign: 'right', wordBreak: 'break-word' }}>
                                                    {value}
                                                </Typography>
                                            )}
                                        </Box>
                                    ))
                                }
                            </Box>
                        )}
                    </Box>
                </DialogContent>

                <DialogActions sx={{ pb: 2, pr: 3 }}>
                    <Button onClick={handleCloseDialog} variant="contained" sx={{ backgroundColor: '#1C4E80' }}>
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>





        </Box>

    );
};

export default Users;